import "core-js/modules/es6.array.reduce";
import "core-js/modules/es6.regexp.split";
import { __awaiter, __extends, __generator, __read } from "tslib";
import { CookieStorage } from './cookie';

var UTMCookie =
/** @class */
function (_super) {
  __extends(UTMCookie, _super);

  function UTMCookie() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  UTMCookie.prototype.get = function (key) {
    return __awaiter(this, void 0, void 0, function () {
      var value, entries, _a;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            _b.trys.push([0, 2,, 3]);

            return [4
            /*yield*/
            , this.getRaw(key)];

          case 1:
            value = _b.sent();

            if (!value) {
              return [2
              /*return*/
              , undefined];
            }

            entries = value.split('.').splice(-1)[0].split('|');
            return [2
            /*return*/
            , entries.reduce(function (acc, curr) {
              var _a = __read(curr.split('=', 2), 2),
                  key = _a[0],
                  _b = _a[1],
                  value = _b === void 0 ? '' : _b;

              if (!value) {
                return acc;
              }

              acc[key] = decodeURIComponent(value);
              return acc;
            }, {})];

          case 2:
            _a = _b.sent();
            return [2
            /*return*/
            , undefined];

          case 3:
            return [2
            /*return*/
            ];
        }
      });
    });
  };

  UTMCookie.prototype.set = function () {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        return [2
        /*return*/
        , undefined];
      });
    });
  };

  return UTMCookie;
}(CookieStorage);

export { UTMCookie };